import { List } from "@mantine/core";
import { generatePath, Link, useParams } from "react-router";
import { TABS as ENERGY_DATA_TABS } from "../../../../../components/EnergyData/EnergyDataView/EnergyDataView";
import { ROUTES } from "../../../../../routes";
import type { Paragraph6CreatableCredit } from "../../../Paragraph6.types";

interface FiktiveStrommengenHintsProps {
  billingPeriods: Array<Paragraph6CreatableCredit>;
}

function FiktiveStrommengenHints({
  billingPeriods
}: FiktiveStrommengenHintsProps) {
  const { projectId } = useParams<{ projectId: string }>();

  if (billingPeriods.length === 0) {
    return null;
  }

  const fiktiveStrommengenPath = projectId
    ? `${generatePath(
        `${ROUTES.energyData.entry}/${ENERGY_DATA_TABS.TAB_ENERGY_DATA_UPLOAD}`,
        { projectId }
      )}#fictional-energy-values`
    : undefined;

  return (
    <List.Item>
      {fiktiveStrommengenPath ? (
        <Link to={fiktiveStrommengenPath}>Fiktive Strommengen</Link>
      ) : (
        <strong>Fiktive Strommengen</strong>
      )}
      , die den Abrechnungszeitraum der Gutschrift überschreiten. Sie werden
      gleichmäßig verteilt auf den Zeitraum:{" "}
      {billingPeriods
        .map(
          (billingPeriod) =>
            `${billingPeriod.start_date} bis ${billingPeriod.end_date}`
        )
        .join(", ")}
    </List.Item>
  );
}

export { FiktiveStrommengenHints };
